<section class="spacing2">
    <div class="container-md">

        <div class="row justify-content-center contentWrap">
            <div [innerHTML]="htmlStr"></div>
        </div>

    </div>
</section>